var React = require('react');
var Sliderr = require('react-slick');
var Link = require('react-router').Link
import { browserHistory } from 'react-router'
import { useRouterHistory } from 'react-router'
import { createHashHistory,createHistory } from 'history'
var LanguageStore = require('../../store/LanguageStore')

var languageAction = require('../../actions/languageAction');



var Language = React.createClass({
render(){
    var language_img = this.props.language === '/uk/' ? 'uk' : this.props.language === '/de/' ? 'de' : this.props.language === '/' ? 'rs' : 'error'
    var path = this.props.routes[0].path;
    var url = 'img/lang/'+language_img+'.png'
      return(<img onClick={this.handleClick} src={url} alt={language_img+' language'}/>)
    },
    handleClick(){
        var url = this.props.routes[0].path ? this.props.language+this.props.routes[0].path : this.props.language
        var lang = this.props.language === '/' ? 'rs' : this.props.language === '/uk/' ? 'uk' : this.props.language === '/de/' ? 'de' : null
        //var lang = this.props.language.slice(1, -1);
        this.props.history.push(this.props.language)
        languageAction.setLanguage(lang);
    }
});

module.exports=Language



/** WEBPACK FOOTER **
 ** ./modules/components/Navigation/Language.js
 **/